/** @jsx jsx */
import { jsx } from 'theme-ui';
import React from 'react';
import hhmmss from 'hhmmss';
import { jsx as ___EmotionJSX } from "@emotion/core";
export default (function (props) {
  var _React$useState = React.useState(0),
      seconds = _React$useState[0],
      setSeconds = _React$useState[1];

  var _React$useState2 = React.useState(false),
      active = _React$useState2[0],
      setActive = _React$useState2[1];

  React.useEffect(function () {
    var timer = setInterval(function () {
      if (!active) return;
      setSeconds(function (n) {
        return n + 1;
      });
    }, 1000);
    return function () {
      clearInterval(timer);
    };
  }, [active]);
  return jsx("button", {
    onClick: function onClick(e) {
      setActive(!active);
      if (active) setSeconds(0);
    },
    title: active ? 'Stop Timer' : 'Start Timer',
    sx: {
      appearance: 'none',
      fontFamily: '"Roboto Mono", Menlo, monospace',
      fontSize: 'inherit',
      color: 'white',
      bg: 'black',
      border: 0,
      padding: 2
    }
  }, hhmmss(seconds));
});